import { render, staticRenderFns } from "./password-change.form.vue?vue&type=template&id=0bcb2b9a&"
import script from "./password-change.form.vue?vue&type=script&lang=js&"
export * from "./password-change.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports